export default {
  meta: {
    title: "PixelHaha {'|'} Imágenes de archivo gratuitas para descargar",
    description:
      "Explora una amplia variedad de imágenes impresionantes. Desde paisajes hasta arte abstracto, todas las imágenes son gratuitas y perfectas para enriquecer tus ideas de diseño y gráficos para redes sociales.",
    keywords: "Gratis, stock, galería, texto a imagen, generación de IA",
    searchTitle:
      "PixelHaha  {number}+ Best {keyword} · Descarga 100 % gratuita",
    searchDescription:
      "Descarga las imágenes perfectas de {keyword}. Encuentra más de {number}+ de las mejores imágenes gratuitas de {keyword}. Gratis para uso comercial No se requiere atribución Libre de derechos de autor.",
    404: "Error 404 - PixelHaha",
  },
};
